import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateLessonBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const createLesson = createAsyncThunk<string, CreateLessonBody, { extra: Partial<Dependencies> }>(
  "lessons/createLesson",
  async (body: CreateLessonBody, { extra: { teacherRepository } }) => {
    return teacherRepository!.createLesson(body);
  },
);

export const resetCreateLesson = createAction("lessons/resetCreateLesson");
